import {cs}       from "@Common/react/chain-services";
import {scnv}     from "@Common/react/state-change-nested-value";
import {UseState} from "@Common/react/use-state";

export const HistoryState = ({initValue=undefined, canSwallowLastStep, next}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => (!initValue ? {
            index: -1,
            list: [],
        } : {
            index: 0,
            list: [initValue],
        }),
        next,
    })],
    ({state}) => next({
        value: state.value.list[state.value.index],

        ...(state.value.index > -1) && {
            canUndo: true,
            undo: () => scnv(state, ["index"], (i) => i-1),
        },

        ...(state.value.list.length > state.value.index + 1) && {
            canRedo: true,
            redo: () => scnv(state, ["index"], (i) => i+1),
        },

        change: (fn) => state.change((s) => {
            const newStep = fn(s.list[s.index]);
            if (!canSwallowLastStep(newStep, s.list[s.index])) {
                return ({
                    index: s.index + 1,
                    list: [
                        ...(s.list ?? []).slice(0, s.index + 1),
                        newStep,
                    ],
                });
            } else {
                return {
                    index: s.index,
                    list: [
                        ...(s.list ?? []).slice(0, s.index),
                        newStep,
                    ],
                };
            }
        }),
    }),

)